import React from "react";
import PropTypes from "prop-types";

export const FeedCardBadge = ({ children = null, className = "" }) => (
  <div className={`badge ${className}`}>{children}</div>
);

FeedCardBadge.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string
};

export default FeedCardBadge;
